export default function () {
  return {
    currentCompany: null,
    agentStatuses: [],
    timezones: []
  }
}
